module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_akt-b395d55635d1a6daca5780973acd22dd.png";